import React, { useEffect, useState } from 'react';
import { ReactComponent as ContextualHelpIconMain } from '../../assets/icons/contextual-help-main.svg';
import { ReactComponent as ContextualHelpIconMainHover } from '../../assets/icons/contextual-help-main-hover.svg';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';
import { IconButton } from '@material-ui/core';
import { useStyles } from './ContextualHelp.styles';
import { ContextualHelpDetails } from '../../services/contextualHelp/contextualHelp.types';
import { getContextualHelpDetails } from '../../services/contextualHelp/contextualHelp.service';
import { AxiosResponse } from 'axios';
import { useLayoutContext } from '../../Context/Layout.context';

interface ContextualHelpProps {
  id: number;
  className?: string;
  buttonClassName?: string;
  tooltipClassName?: string;
  isActive: boolean;
  onClick: (id: number | undefined) => void;
  placement?:
    | 'left'
    | 'right';
}

export const ContextualHelp: React.FC<ContextualHelpProps> = (props) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [url, setUrl] = useState<string | undefined>('');

  const classes = useStyles();
  const { openAlert } = useLayoutContext();

  const styles = {
    zIndex: 2000,
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (url) {
        window.open(url, '_blank');
    }
  };

  useEffect(() => {
    getContextualHelpDetails(props.id)
      .then((response: AxiosResponse<ContextualHelpDetails>) => {
        setTitle(response.data.title);
        setDescription(response.data.description);
        setUrl(response.data.url);
      })
      .catch(() => {
        openAlert('get_error');
      });
  });

  return (
    <div className={`${classes.contextualHelpDiv} ${props.className}`} id={`contextualHelp-${props.id}`}>
      <div>
        <TooltipOne title={props.isActive ? '' : title} placement="bottom">
          <IconButton disableRipple className={`${classes.animatedItem} ${props.buttonClassName}`} style={styles} onClick={() => { props.onClick(props.isActive ? undefined : props.id) }}>
            {props.isActive ? (
              <ContextualHelpIconMainHover className={classes.contextualHelpIcon} />
            ) : (
              <ContextualHelpIconMain className={classes.contextualHelpIcon} />
            )}
          </IconButton>
        </TooltipOne>
      </div>
      {props.isActive && (
        <div className={`${classes.contextualHelpTooltipFlex} ${props.tooltipClassName} ${props.placement === "left" ? classes.contextualHelpLeftTooltip : classes.contextualHelpRightTooltip}`}>
          <span className={classes.closeButton} onClick={() => { props.onClick(undefined) }}>
            x
          </span>
          <p className={classes.title}>{title}</p>
          <p className={classes.description}>{description}</p>
          {url && 
            <p className={classes.url}>
                <a 
                  href={url}
                  onClick={handleLinkClick}
                  rel="noopener noreferrer"
                >
                  Dowiedz się więcej...
                </a>
            </p>}
        </div>
      )}
    </div>
  );
};
